// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1XRVd","inputWrap":"Table_inputWrap__pCqed","col":"Table_col__15zc6","bmiTooltip":"Table_bmiTooltip__RTB_K"};